import { createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { DIALOG_DRAFTS_STORAGE_KEY } from "./constants"

export interface DialogDraft {
    id: string
    content: string
}

const adapter = createEntityAdapter<DialogDraft>()

const loadInitialState = () => {
    try {
        const data = localStorage.getItem(DIALOG_DRAFTS_STORAGE_KEY)
        const items: DialogDraft[] = data ? JSON.parse(data) : []
        return adapter.setAll(adapter.getInitialState(), items)
    } catch {
        return adapter.getInitialState()
    }
}

const slice = createSlice({
    name: "dialogDrafts",
    initialState: loadInitialState(),
    reducers: {
        upsertDraft: (state, action: PayloadAction<DialogDraft>) => {
            adapter.upsertOne(state, action.payload)
        },
        removeDraft: (state, action: PayloadAction<string>) => {
            adapter.removeOne(state, action.payload)
        },
        clearDrafts: state => {
            adapter.removeAll(state)
        }
    }
})

export const DialogDraftsReducer = slice.reducer
export const { upsertDraft, removeDraft, clearDrafts } = slice.actions
export const dialogDraftsAdapter = adapter
